exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700,800,900&display=swap);", ""]);

// module
exports.push([module.id, ".Button-module__button___3M5qQ{padding:8px 20px;background-color:#32385f;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;color:#fff;cursor:pointer;margin:10px 0;display:block;font-weight:700}", ""]);

// exports
exports.locals = {
	"button": "Button-module__button___3M5qQ"
};